import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

import getPeriodsSchema from 'components/shared/ControlledFields/ControlledTimePeriods/ControlledTimePeriodsSchema';
import { PlanUnit } from '../../types';

const periodsSchema = getPeriodsSchema();

function getSchema() {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup
    .object({
      workAgreementId: yup
        .number()
        .required(t('validationFieldRequired', { name: t('workAgreement') })),
      planUnit: yup
        .mixed<PlanUnit>()
        .required(t('validationFieldRequired', { name: t('planUnit') })),
      periods: periodsSchema
    })
    .required();
}

export default getSchema;
